import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { ROUTE_MAP } from "../constants/routes";
import { getRouteLang } from "../utils/language";

/**
 * Pure function — zwraca zlokalizowaną ścieżkę dla danego klucza route.
 * Można używać w useMemo, event handlerach i poza komponentami React.
 *
 * localizedPath("dashboard")                    → "/pulpit" (pl) / "/dashboard" (en)
 * localizedPath("newsDetail", { slug: "abc" })  → "/aktualnosci/abc" (pl)
 * localizedPath("ticketDetail", { id: 5 })      → "/zgloszenia/5" (pl)
 */
export function localizedPath(routeKey, params = {}) {
    const lang = getRouteLang();
    const route = ROUTE_MAP[routeKey];
    if (!route) {
        console.warn(`[localizedPath] Unknown route key: "${routeKey}"`);
        return routeKey; // fallback: traktuj jako surowy path
    }
    let path = route[lang] || route.en;
    // Zamień :param placeholders na wartości
    for (const [param, value] of Object.entries(params)) {
        path = path.replace(`:${param}`, encodeURIComponent(value));
    }
    return path;
}

/**
 * Hook — drop-in replacement dla useNavigate() z obsługą kluczy route.
 *
 * const navigate = useLocalizedNavigate();
 * navigate("dashboard");
 * navigate("newsDetail", { slug: "abc" });
 * navigate(-1); // nadal działa
 */
export function useLocalizedNavigate() {
    const navigate = useNavigate();

    return useCallback(
        (routeKeyOrDelta, paramsOrOptions, options) => {
            // navigate(-1), navigate(0) itp.
            if (typeof routeKeyOrDelta === "number") {
                return navigate(routeKeyOrDelta);
            }
            const path = localizedPath(routeKeyOrDelta, paramsOrOptions || {});
            navigate(path, options);
        },
        [navigate]
    );
}
